import loader from "../img/loader.gif";

export default function Loader() {
  return (
    <>
      <div>
        <img style={{ width: "50px" }} src={loader} alt="" />
      </div>
    </>
  );
}
